/* This is generated code, don't alter */
var IfcProcedureTypeEnum;
(function (IfcProcedureTypeEnum) {
    IfcProcedureTypeEnum[IfcProcedureTypeEnum["ADVICE_CAUTION"] = 0] = "ADVICE_CAUTION";
    IfcProcedureTypeEnum[IfcProcedureTypeEnum["ADVICE_NOTE"] = 1] = "ADVICE_NOTE";
    IfcProcedureTypeEnum[IfcProcedureTypeEnum["ADVICE_WARNING"] = 2] = "ADVICE_WARNING";
    IfcProcedureTypeEnum[IfcProcedureTypeEnum["CALIBRATION"] = 3] = "CALIBRATION";
    IfcProcedureTypeEnum[IfcProcedureTypeEnum["DIAGNOSTIC"] = 4] = "DIAGNOSTIC";
    IfcProcedureTypeEnum[IfcProcedureTypeEnum["SHUTDOWN"] = 5] = "SHUTDOWN";
    IfcProcedureTypeEnum[IfcProcedureTypeEnum["STARTUP"] = 6] = "STARTUP";
    IfcProcedureTypeEnum[IfcProcedureTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcProcedureTypeEnum[IfcProcedureTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcProcedureTypeEnum || (IfcProcedureTypeEnum = {}));
const IfcProcedureTypeEnumCount = 9;
export { IfcProcedureTypeEnum, IfcProcedureTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcProcedureTypeEnum = new Int32Array([60, 1, 8]);
let prefixSumAddressIfcProcedureTypeEnum = new Uint32Array([0, 13, 25, 35, 48, 64, 73, 86, 102, 114]);
let slotMapIfcProcedureTypeEnum = new Int32Array([1, 4, 5, 3, 2, 6, 7, 0, 8]);
let encodedDataIfcProcedureTypeEnum = (new TextEncoder()).encode(".ADVICE_NOTE..DIAGNOSTIC..SHUTDOWN..CALIBRATION..ADVICE_WARNING..STARTUP..USERDEFINED..ADVICE_CAUTION..NOTDEFINED.");
let IfcProcedureTypeEnumSearch = new MinimalPerfectHash(gMapIfcProcedureTypeEnum, prefixSumAddressIfcProcedureTypeEnum, slotMapIfcProcedureTypeEnum, encodedDataIfcProcedureTypeEnum);
export { IfcProcedureTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcProcedureTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcProcedureTypeEnumSearch, input, cursor, endCursor);
}
